import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AccordionModule } from '../accordion/accordion.module';
import { IconModule } from '../icon/icon.module';
import { StepperComponent } from './components/stepper/stepper.component';

@NgModule({
  declarations: [StepperComponent],
  imports: [CommonModule, IconModule, AccordionModule],
  exports: [StepperComponent, CdkStepperModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StepperModule {}
